import { styled, Box } from "@mui/material";

export const SelectedSummaryRoot = styled(Box)(({ theme }) => ({
  width: "100%",
  zIndex: 9,
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
}));
